<template>
  <div class="auth-callback">
    <div class="loading-container">
      <div class="spinner"></div>
      <p>Processando login...</p>
    </div>
  </div>
</template>

<script>
import { KeycloakUtils, keycloakConfig } from "@/config/keycloak";
import Api from "@/service/api-web";

export default {
  name: "AuthCallback",

  async created() {
    try {
      const { code } = KeycloakUtils.handleCallback();

      const response = await Api.api.post("/keycloak-auth", {
        code: code,
        redirectUri: keycloakConfig.redirectUri
      });

      const {
        authorization,
        authorization1,
        authorization2,
        authorization3,
        funcao,
        keycloakToken,
        refreshToken,
        expiresIn
      } = response.data;

      this.$store.commit("AUTH_LOGIN", {
        authorization,
        authorization1,
        authorization2,
        authorization3,
        funcao,
        keycloakToken,
        refreshToken
      });

      if (expiresIn) {
        const cookieConfig = { expires: 365, secure: true };
        const expiryTime = Date.now() + expiresIn * 1000;
        KeycloakUtils.setCookie(
          "token_expires_at",
          expiryTime.toString(),
          cookieConfig
        );
        KeycloakUtils.startTokenRefreshTimer(expiresIn);
      }

      if (funcao === "adm") {
        window.location.href = "/admin";
      } else {
        window.location.href = "/fornecedor/inicio";
      }

      this.$vueOnToast.pop("success", "Login efetuado com sucesso");
    } catch (error) {
      this.$vueOnToast.pop(
        "error",
        "Erro no processo de login. Tente novamente."
      );
      this.$router.push("/login");
    }
  }
};
</script>

<style scoped>
.auth-callback {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.loading-container {
  text-align: center;
}

.spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #558ed0;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 2s linear infinite;
  margin: 0 auto 20px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
